import {
  GET_PROFILE,
  GET_PROFILE_FAIL,
  GET_PROFILE_SUCCESS,
  UPDATE_PROFILE,
  UPDATE_PROFILE_FAIL,
  UPDATE_PROFILE_SUCCESS, 
  UPDATE_PROFILEPW,
  UPDATE_PROFILEPW_FAIL,
  UPDATE_PROFILEPW_SUCCESS,
  RESET_PROFILE_STATE,
} from "./actionTypes";

//company profile
export const getProfile = page => ({
  type: GET_PROFILE,
  payload: page,
});

export const getProfileSuccess = profile => ({
  type: GET_PROFILE_SUCCESS,
  payload: profile,
});

export const getProfileFail = error => ({
  type: GET_PROFILE_FAIL,
  payload: error,
});

//update profile
export const updateProfile = ({ profile }) => ({
  type: UPDATE_PROFILE,
  payload: { profile },
});

export const updateProfileSuccess = profile => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: profile,
});

export const updateProfileFail = error => ({
  type: UPDATE_PROFILE_FAIL,
  payload: error,
});

//update profile pw
export const updateProfilePW = ({ profile }) => ({
  type: UPDATE_PROFILEPW,
  payload: { profile },
});

export const updateProfilePWSuccess = profile => ({
  type: UPDATE_PROFILEPW_SUCCESS,
  payload: profile,
});

export const updateProfilePWFail = error => ({
  type: UPDATE_PROFILEPW_FAIL,
  payload: error,
});

//reset
export const resetProfileState = () => {
  return {
    type: RESET_PROFILE_STATE,
  }
}


